import React from "react";
import toast from "react-hot-toast";
import FeesContext from "contexts/feesContext";
import { addFee, deleteFee, getFees, updateFee } from "api/DynamicFeesAPI";
import { IDynamicFeesCreate } from "../types/fees.interface";

const useFeesTable = () => {
  const { setFees } = React.useContext(FeesContext);

  const getDynamicFeesTableData = async () => {
    try {
      const response = await getFees();
      setFees(response.data.data);
    } catch (error) {
      toast.error("Gagal mengambil data biaya tambahan");
    }
  };

  const onSubmit = async (data: IDynamicFeesCreate) => {
    const value =
      typeof data.value === "string"
        ? data.value.replace(/\D/g, "")
        : data.value;
    data.value = value;

    const promise = addFee(data);

    toast.promise(promise, {
      loading: "Menambahkan biaya tambahan...",
      success: () => {
        getDynamicFeesTableData();
        return "Berhasil menambahkan biaya tambahan";
      },
      error: "Gagal menambahkan biaya tambahan",
    });
  };

  const onDelete = async (id: number) => {
    const promise = deleteFee(id);

    toast.promise(promise, {
      loading: "Menghapus biaya tambahan...",
      success: () => {
        getDynamicFeesTableData();
        return "Berhasil menghapus biaya tambahan";
      },
      error: "Gagal menghapus biaya tambahan",
    });
  };

  const onUpdate = async (id: number, data: IDynamicFeesCreate) => {
    const value =
      typeof data.value === "string"
        ? data.value.replace(/\D/g, "")
        : data.value;
    data.value = value;

    const promise = updateFee(id, data);

    toast.promise(promise, {
      loading: "Memperbarui biaya tambahan...",
      success: () => {
        getDynamicFeesTableData();
        return "Berhasil memperbarui biaya tambahan";
      },
      error: "Gagal memperbarui biaya tambahan",
    });
  };

  return {
    getDynamicFeesTableData,
    onSubmit,
    onDelete,
    onUpdate,
  };
};

export default useFeesTable;
